<script>
import ContactStrip from "@/components/parts/ContactStrip.vue";

export default {
  name: "Accounting Services",
  components: {ContactStrip},
  metaInfo: {
    title: ' Accounting Services',
    meta: [{
      content: 'At FINCOR we provide financial accounting services such as: Complete Financial Management, Preparation of Annual Accounts, Budget Preparations, Compliance Monitoring and CFO Services.'
    }]
  }
}
</script>

<template>
  <transition name="slide-fade" >
    <div>
      <div class="uk-padding ">
        <h1 class="uk-heading-line uk-text-center"><span> Accounting Services</span></h1>
        <div class="uk-container uk-container-small" >
          <p>
            FINCOR offers a full accounting package that is turnkey and hassle free. Our customers pay a fixed
            monthly fee, we provide the office, printer, internet, software, staff, and all other resources necessary
            to deliver a complete accounting support function for your business. You remain in control of key
            decisions, and you always have access to your information so you can understand what is happening in
            your business.
            <br><br>
            Each client receives a customized service based on their needs, we can either support the staff you have
            now, or take over the full finance function.
          </p>


          <h3 class="uk-heading-bullet  h2Style" id="complete-financial-management">Complete Financial Management</h3>
          <p>
            We will work with you as a trusted partner to ensure that the
            finances of your business are well managed. We have years of experience managing the full accounting
            cycle from data entry to completion of annual financial statements at a cost that is a fraction of full-time
            staff.
          </p>
          <p>
            You didn’t get into business for the Admin work, we free you up to realize your vision and to do what
            you enjoy by ensuring your clients are invoiced on time, staff are paid, benefits are managed, vendor
            obligations are settled, and your cash flow supports your long-term goals and obligations. You also get
            CFO level advisory services from a team of Certified accountants with decades of experience.
          </p>
        </div>
      </div>
      <div class="uk-padding uk-background-muted"  id="preparation-of-annual-accounts">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Preparation of Annual Accounts</h3>
          <p>
            Looking for professional financial statements for your bank or to give
            your partners, shareholders, or management team a clear understanding of how your business is
            performing? Trust FINCOR to deliver professional accurate financial statements including management
            discussion and analysis, supporting notes, charts, and breakdowns.
          </p>
          <p>
            Our clients receive IFRS and GAAP
            compliant financials that tell them exactly how their business is performing at agreed frequencies
            (monthly/quarterly/annually). Give us a call or schedule a consultation <a href="/contact-us">here</a>.
          </p>
        </div>
      </div>
      <div class="testStep">
        <div class="uk-padding uk-background-muted" style="background: rgba(0, 0, 0, 0.9)">
          <div class="uk-container uk-container-large">
            <div class="uk-child-width-1-2@l" uk-grid>
              <div id="budget-preparations">
                <h3 class="uk-heading-bullet h2Style">Budget Preparations</h3>
                <p>
                  Are you setting the financial targets for your organization for the upcoming
                  period? Are you looking to work with professionals who can review your proposed spend, show you the
                  impact of your business assumptions and identify opportunities to save costs?
                </p>
                <p>
                  FINCOR can help, we have
                  years of experience helping organizations develop multi-million-dollar budgets, operate more efficiently
                  and present budget information to stakeholders ranging from banks to Parliament.
                </p>

              </div>
              <div id="compliance-monitoring">
                <h3 class="uk-heading-bullet h2Style">Compliance Monitoring</h3>
                <p>
                  Are you a bank looking for a firm to monitor and report on your client’s
                  business as a condition of your loan?
                  <br><br>
                  Trust FINCOR to provide objective third-party professional
                  reporting, and to also work with your client providing professional advice to ensure compliance with the
                  loan agreement.

                </p>

              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted" id="cfo-services">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet h2Style">CFO Services</h3>
          <p>
            Do you have lower-level bookkeeping staff that do the day to day postings and functions
            but looking for an experienced qualified accountant to review their work, provide reporting and advice?
            We offer decades of experience managing the finances of businesses of all levels.
          </p>
          <p>
            We can provide
            monthly reviews, ensure clients are billed and money is coming in, bills are being paid, reporting
            requirements are being met, reconciliations are carried out etc. We also provide support for staff to
            answer questions, interface with the bank or other stakeholders.
          </p>
        </div>
      </div>
      <ContactStrip />

    </div>
  </transition>
</template>

<style scoped>
.h2Style{
  font-family: 'Overlock SC';

}
.testStep{
  background-image: url('~@/assets/spreadsheet.jpg');
  background-size: cover;
}
.testStep *{
  color: silver;
}
</style>